import script from "./FSaveRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./FSaveRecommendations.vue?vue&type=script&setup=true&lang=ts"

import "./FSaveRecommendations.vue?vue&type=style&index=0&id=f0f53460&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0f53460"]])

export default __exports__